import { PropsWithChildren } from 'react';
import { useFetchAdminCampaignsEffect } from 'features/admin-campaigns/components/WithAdminCampaigns/effects/useFetchAdminCampaignsEffect';
import { useFetchAdminDatasetsEffect } from 'features/admin-campaigns/components/WithAdminCampaigns/effects/useFetchAdminDatasetsEffect';
import { useFetchAdminSchedulesEffect } from 'features/admin-campaigns/components/WithAdminCampaigns/effects/useFetchAdminSchedulesEffect';
import { useResetAdminDataOnUnmountEffect } from 'features/admin-campaigns/components/WithAdminCampaigns/effects/useResetAdminDataOnUnmountEffect';

export function WithAdminCampaigns({ children }: PropsWithChildren) {
  useFetchAdminCampaignsEffect();
  useFetchAdminDatasetsEffect();
  useFetchAdminSchedulesEffect();
  useResetAdminDataOnUnmountEffect();

  return <>{children}</>;
}
